import { useQueryClient } from '@tanstack/react-query';
import { unsetCommonHeaders } from '_api/base';

export const useLogout = () => {
  const queryClient = useQueryClient();

  const clear = () => {
    unsetCommonHeaders();
    queryClient.clear();
  };

  return { clear };
};
